import { environment } from "../../../ENV";
//let environment = 'development';

function getUrl() {
  switch (environment) {
    case "development":
      return {
        _chatBubbleButton: "http://localhost:8081",
        _chatWindow: "http://localhost:8082",
        _autoMessage: "http://localhost:8083",
      };
    case "stage":
      return {
        _chatBubbleButton: "http://stageclient.jibber.se/bubble",
        _chatWindow: "http://stageclient.jibber.se/chat",
        _autoMessage: "http://stageclient.jibber.se/auto",
      };
    case "production":
      return {
        _chatBubbleButton: "https://client.jibber.social/bubble",
        _chatWindow: "https://client.jibber.social/chat",
        _autoMessage: "https://client.jibber.social/auto",
      };
  }
}

export default getUrl();



// WEBPACK FOOTER //
// ./common/js/lib/clientChatUrl.js